import { Injectable } from '@angular/core';
import { CommandFactoryService } from '../../../../core/service/factory/command-factory.service';
import { LeaseAgreementFilteredCommand, LeaseAgreementMultiselectCommand } from '../../../command/lease-agreement.command';
import { MultiselectCommand } from '../../../../core/model/command';
import { LeaseAgreementCategory } from '../../../model/const/enums';

@Injectable()
export class DwellingContractCommandFactory extends CommandFactoryService {
  constructor() {
    super();
  }

  createFilteredCommand(id: string, excludedIds: string[], includedIds: string[], totalAffectedItemsControlValue: number) {
    return new LeaseAgreementFilteredCommand(id, excludedIds, includedIds, totalAffectedItemsControlValue, LeaseAgreementCategory.Dwelling);
  }

  createMultiselectCommand(id: string, items: any[], itemsSource: any[], contextId?: string): MultiselectCommand {
    return new LeaseAgreementMultiselectCommand(id, items, LeaseAgreementCategory.Dwelling, itemsSource, contextId);
  }
}
